import { Tabs } from 'expo-router';
import { Platform } from 'react-native';

import { AnimatedTabBar } from '@/components/AnimatedTabBar';
import { ExploreIcon, GroupsIcon, ProfileIcon, RecordIcon } from '@/components/NavIcons';
import theme from '@/constants/colors';
import { useTranslation } from 'react-i18next';

export default function TabLayout() {
  const { t } = useTranslation();
  return (
    <Tabs
      tabBar={(props) => <AnimatedTabBar {...props} />}
      screenOptions={{
        headerShown: false,
        tabBarActiveTintColor: theme.backgroundSecondaryVarient,
        tabBarInactiveTintColor: theme.backgroundPrimary,
      }}
    >
      <Tabs.Screen
        name="explore"
        options={{
          title: t('tabs.explore'),
          tabBarIcon: ({ color, size }) => <ExploreIcon size={size} color={color} />,
        }}
      />
      <Tabs.Screen
        name="groups"
        options={{
          title: t('tabs.groups'),
          tabBarIcon: ({ color, size }) => <GroupsIcon size={size} color={color} />,
        }}
      />
      {Platform.OS !== 'web' && (
        <Tabs.Screen
          name="record"
          options={{
            title: t('tabs.record'),
            tabBarIcon: ({ color, size }) => <RecordIcon size={size} color={color} />,
          }}
        />
      )}
      <Tabs.Screen
        name="profile"
        options={{
          title: t('tabs.profile'),
          tabBarIcon: ({ color, size }) => <ProfileIcon size={size} color={color} />,
        }}
      />
    </Tabs>
  );
}
